import { render, staticRenderFns } from "./StudentRegistrationCursusAdmin.vue?vue&type=template&id=daa45c64"
import script from "./StudentRegistrationCursusAdmin.vue?vue&type=script&lang=js"
export * from "./StudentRegistrationCursusAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports